import { acquireToken } from '../../auth/acquireToken';
import { getCachedSession } from './sessionCache';

export const getAuthHeaders = async (scopes: string[]): Promise<Headers> => {
	const session = getCachedSession();

	const token = await acquireToken(scopes.join(';'));
	if (!token) {
		throw 'NO BEARER TOKEN';
	}

	const headers = new Headers();
	const bearer = `Bearer ${token}`;

	headers.append('Accept', 'application/json');
	headers.append('Authorization', bearer);

	if (session?.isTestUser) {
		headers.append('x-test-user', session.user.email + '###' + session.user.name);
	}

	return headers;
};
